import axios from './../plugins/private-api-axios'

export const snapshotPackageService = {
    urlPrefix: '/snapshotPackages',
    config: {
        headers: {
            Authorization: ''
        }
    },
    async createSnapshotPackage (name, description, journeyDate, expirationDate, vehicleId, snapshotsIds) {
        try {
            return await axios.post(`${this.urlPrefix}`, {
                name: name,
                description: description,
                date: journeyDate,
                expirationDate: expirationDate,
                vehicleId: vehicleId,
                snapshotIds: snapshotsIds
            }, this.config)
        } catch (e) {
            throw e
        }
    },
    async updateSnapshotPackage (id, name, description, expirationDate, vehicleId) {
        try {
            return await axios.put(`${this.urlPrefix}`, {
                id: id,
                name: name,
                description: description,
                expirationDate: expirationDate,
                vehicleId: vehicleId
            }, this.config)
        } catch (e) {
            throw e
        }
    },
    async getSnapshotPackages (vehicleId, journeyDate, page, perPage) {
        let urlBuilder = {
            'VehicleId': vehicleId,
            'DateFrom': journeyDate,
            'Skip': (page - 1) * perPage,
            'Take': perPage
        }
        try {
            return await axios.get(`${this.urlPrefix}?${new URLSearchParams(urlBuilder).toString()}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async getSnapshotPackage (packageId) {
        try {
            return await axios.get(`${this.urlPrefix}/${packageId}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async getSnapshotPackageDownload (packageId) {
        try {
            return await axios.get(`${this.urlPrefix}/download/${packageId}`, this.config)
        } catch (e) {
            throw e
        }
    }
}

export const updatesnapshotPackageService = (accessToken) => {
    snapshotPackageService.config.headers.Authorization = accessToken
}

export default snapshotPackageService
